import { ManagementStrategy, UserManagementActivationStatus } from "./types";

export function getManagementStrategy(activationStatus: UserManagementActivationStatus) {
  return activationStatus === UserManagementActivationStatus.ACTIVE
    ? ManagementStrategy.USER_MANAGEMENT
    : ManagementStrategy.LOGIN_POLICY;
}
